import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {
  public YoutubeVideo: SafeResourceUrl;
  BigImage: any;
  constructor(
    private meta: Meta,
    private title: Title,
    // tslint:disable-next-line: variable-name
    private _sanitizer: DomSanitizer,
    config: NgbModalConfig,
    private modalService: NgbModal
  ) {
    config.backdrop = true;
    config.keyboard = true;
  }
  videos = [
    {image: 'assets/images/jpg/video-1.jpg', alt: 'Message', desc: 'Overview', videoId: '2KNueR_I2mU'},
    {image: 'assets/images/jpg/video-2.jpg', alt: 'Salon Franchise', desc: 'Salon Franchise', videoId: 'A1JqF97GQ6w'},
    {image: 'assets/images/jpg/video-3.jpg', alt: 'Message', desc: 'Demonstration', videoId: 'UqKVa_4xPG0'},
    {image: 'assets/images/jpg/video-4.jpg', alt: 'Message', desc: 'Laguna Beach House', videoId: 'ezEqnJ7zWHI'}
  ];
  images = [
    {image: 'assets/images/jpg/Gallery-1.jpg', alt: 'Message', bigimage: 'assets/images/jpg/Gallery-1-high.jpg'},
    {image: 'assets/images/jpg/Gallery-2.jpg', alt: 'Message', bigimage: 'assets/images/jpg/Gallery-2-high.jpg'},
    {image: 'assets/images/jpg/Gallery-3.jpg', alt: 'Message', bigimage: 'assets/images/jpg/Gallery-3-high.jpg'},
    {image: 'assets/images/jpg/Gallery-4.jpg', alt: 'Message', bigimage: 'assets/images/jpg/Gallery-4-high.jpg'},
    {image: 'assets/images/jpg/Gallery-5.jpg', alt: 'Message', bigimage: 'assets/images/jpg/Gallery-5-high.jpg'},
    {image: 'assets/images/jpg/Gallery-6.jpg', alt: 'Message', bigimage: 'assets/images/jpg/Gallery-6-high.jpg'},
    {image: 'assets/images/jpg/Gallery-7.jpg', alt: 'Message', bigimage: 'assets/images/jpg/Gallery-7-high.jpg'},
  ];
  ngOnInit() {
    this.title.setTitle('Massage Robotics - Just for the feel of it');
    this.meta.updateTag({ name: 'Description', content: 'Massage Robotics' });
    this.meta.updateTag({ name: 'Keywords', content: 'Massage Robotics' });
  }
  playYoutube(content, video) {
    this.modalService.open(content, { centered: true, windowClass: 'MyYoutube', size: 'lg' });
    // tslint:disable-next-line: max-line-length
    this.YoutubeVideo = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + video + '?autoplay=1&cc_load_policy=1');
  }
  ShowImage(content, image) {
    this.modalService.open(content, { centered: true, windowClass: 'MyYoutube', size: 'lg' });
    this.BigImage = image;
  }

}
